import type { Ref } from '#imports';
import { authApi as defaultAuthApi } from '~/services/auth.service';
import type { AuthApi, AuthUserDto } from '~/types/ports/auth.api';

export type UseFetchCurrentUserDeps = {
  authApi?: AuthApi;
};

export type FetchCurrentUserOptions = {
  token: Ref<string | null | undefined>;
  user: Ref<AuthUserDto | null>;
  isCurrent?: () => boolean;
} & UseFetchCurrentUserDeps;

/**
 * Загрузка текущего пользователя по token.
 */
export async function fetchCurrentUser(
  options: FetchCurrentUserOptions
): Promise<boolean> {
  if (!options.token.value) return false;

  const requestedToken = options.token.value;
  const api = options.authApi ?? defaultAuthApi;
  const loaded = await api.fetchCurrentUser(String(requestedToken));
  if (
    options.token.value !== requestedToken ||
    options.isCurrent?.() === false
  ) {
    return false;
  }
  if (!loaded) {
    throw new Error('fetchCurrentUser: пользователь не получен');
  }
  options.user.value = loaded;
  return true;
}
